<template>
  <a-row :gutter="20" class="dashboard">
    <a-col :span="isDesktop ? 12 : 24">
      <a-card :title="$t('cardTitle.churchMembersAccessCredentials')" class="style1">
        <p v-text="$t('page.churchAccess.churchMembersAccessCredentials.para1')"></p>
        <a-form :form="form" :label-col="isDesktop ? { span: 4 } : {}" :wrapper-col="isDesktop ? { span: 20 } : {}" :layout="isDesktop ? 'horizontal' : 'vertical'" @submit="handleSubmit">
          <a-form-item :label="$t('label.email')">
            <a-input v-decorator="['email', { rules: [{ type: 'email', required: true, message: $t('placeholder.pleaseInputEmail') }] }]" />
          </a-form-item>
          <a-form-item :label="$t('label.password')">
            <a-input type="password" v-decorator="['password', { rules: [{ required: true, message: $t('placeholder.pleaseInputPassword') }] }]" />
          </a-form-item>

          <a-form-item :wrapper-col="{ span: 12, offset: 4 }">
            <a-button type="primary" html-type="submit" :loading="isLoading">{{ $t('button.' + (isExisted ? 'updateUser' : 'createUser')) }}</a-button>
          </a-form-item>

          <a-tag color="green" v-if="!isEmpty(userInfo)" style="width: 100%;">
            <p style="text-align: center; font-size: 16px;">{{ $t('label.churchLoginDetail') }}</p>
            <p v-text="`${$t('label.careLogin')}: ${userInfo.care_login}`" />
            <p v-text="`${$t('label.carePassword')}: ${userInfo.care_pass}`" />
          </a-tag>
        </a-form>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import { mapState } from 'vuex';
import UserService from '@/services/UserService';
import { get, isEmpty } from 'lodash';
export default {
  data: () => ({
    isLoading: false,
    isExisted: false,
    userInfo: {},
  }),
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'churchAccess' });
  },
  computed: {
    ...mapState(['settings']),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
  },
  async mounted() {
    await this.doInitChurchAccessInfo();
    this.isExisted = true;
  },
  methods: {
    isEmpty,
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.isLoading = true;
            const resp = await UserService.doCreateUser(values);
            await this.doInitChurchAccessInfo();
            this.$notification['success']({
              message: 'Create successful.',
              description: `${resp.email} created`,
            });
          } catch (error) {
            console.log(error);
            this.$notification['error']({
              message: error.response.status,
              description: get(error, 'response.data.error', error.message),
            });
          } finally {
            this.isLoading = false;
          }
        }
      });
    },
    async doInitChurchAccessInfo() {
      const respUserInfo = await UserService.doGetUserInfo();
      console.log(respUserInfo);
      this.userInfo = respUserInfo;
    },
  },
};
</script>
